// Typelizer digest a0ce653afca8c21db5678fb5ed3c6f8d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/purchase_orders/:purchase_order_id/deliveries */
  create: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/deliveries', params, options),
    method: 'post',
  }),
}
